(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coreva-content"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click',event=>{const button=event.target.closest('[data-cv-prev],[data-cv-next]');if(!button)return;const track=button.closest('.cv-content').querySelector('[data-cv-carousel]');if(!track)return;const card=track.firstElementChild;track.scrollBy({left:(card.getBoundingClientRect().width+20)*(button.hasAttribute('data-cv-next')?1:-1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coreva-eyewear"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const form=root.querySelector('form'), native=form.querySelector('[name="id"]'), options=[...native.options], packs=[...form.querySelectorAll('[name="cv_pack"]')], pairs=[...form.querySelectorAll('[data-pair]')], atc=form.querySelector('[type="submit"]'), sticky=root.querySelector('.cv-eye-sticky'), stickyButton=sticky.querySelector('button'), error=form.querySelector('[data-error-message]');
    root.querySelector('.cv-eye-builder').hidden=false;root.querySelector('.cv-eye-native').hidden=true;
    let busy=false;
    function current(){const single=packs.find(x=>x.checked).value==='single';const key=single?'single':pairs.map(x=>x.value).sort().join('-');return options.find(x=>x.dataset.key===key);}
    function update(){
      const selected=current(), single=selected.dataset.key==='single', available=selected.dataset.available==='true';
      native.value=selected.value;
      pairs.forEach((x,i)=>{x.disabled=single||busy;const photo=root.querySelector(`[data-pair-photo="${i+1}"]`);photo.querySelector('img').src=x.value==='night'?photo.dataset.nightSrc:photo.dataset.blueSrc;photo.querySelector('img').removeAttribute('srcset');});
      root.querySelector('[data-pairs]').hidden=single;
      root.querySelector('[data-selection]').textContent=single?'':selected.textContent.split(' — ')[0].replace(' + ','\n');
      root.querySelectorAll('[data-price]:not(option)').forEach(x=>x.textContent=selected.dataset.price);
      root.querySelectorAll('[data-compare]:not(option)').forEach(x=>{x.textContent=selected.dataset.compare||'';x.hidden=!selected.dataset.compare;});
      root.querySelector('[data-sticky-title]').textContent=selected.textContent.split(' — ')[0].replace(' + ','\n');
      root.querySelector('[data-draft]').hidden=available;
      atc.disabled=!available||busy;
      root.querySelector('[data-atc-label]').textContent=busy?root.dataset.adding:available?root.dataset.add:root.dataset.unavailable;
    }
    [...packs,...pairs].forEach(x=>x.addEventListener('change',()=>{error.hidden=true;update();}));
    stickyButton.addEventListener('click',()=>{const target=root.querySelector('.cv-eye-options');target.focus({preventScroll:true});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});});
    const syncSticky=()=>{sticky.hidden=atc.getBoundingClientRect().bottom>0;};
    window.addEventListener('scroll',syncSticky,{passive:true});window.addEventListener('resize',syncSticky);syncSticky();
    const track=root.querySelector('.cv-eye-track'), slides=[...track.children], thumbs=[...root.querySelectorAll('[data-slide]')];
    function move(index){track.scrollTo({left:Math.max(0,Math.min(index,slides.length-1))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    root.querySelector('[data-prev]').addEventListener('click',()=>move(Math.round(track.scrollLeft/track.clientWidth)-1));
    root.querySelector('[data-next]').addEventListener('click',()=>move(Math.round(track.scrollLeft/track.clientWidth)+1));
    thumbs.forEach(x=>x.addEventListener('click',()=>move(Number(x.dataset.slide))));
    track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(Math.round(track.scrollLeft/track.clientWidth)+(e.key==='ArrowRight'?1:-1));}});
    track.addEventListener('scroll',()=>{const i=Math.round(track.scrollLeft/track.clientWidth);root.querySelector('[data-counter]').textContent=`${i+1} / ${slides.length}`;thumbs.forEach((x,n)=>x.setAttribute('aria-pressed',String(n===i)));},{passive:true});
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(busy||atc.disabled)return;
      const selected=current();if(selected.dataset.available!=='true')return;
      const body=new FormData(form);body.set('id',selected.value);body.delete('cv_pack');
      if(selected.dataset.key!=='single')body.set('properties[Paketin sisältö]',selected.textContent.split(' — ')[0]);
      busy=true;packs.forEach(x=>x.disabled=true);atc.setAttribute('aria-busy','true');error.hidden=true;update();
      const drawer=document.querySelector('cart-drawer'),cartPath=(window.Shopify?.routes?.root||'/')+'cart';
      if(drawer?.getSectionsToRender){body.set('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));body.set('sections_url',location.pathname);drawer.setActiveElement?.(atc);}
      let added=false;
      try{
        const response=await fetch(cartPath+'/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});const data=await response.json();
        if(!response.ok||data.status)throw new Error(typeof data.description==='string'?data.description:root.dataset.error);
        added=true;
        if(drawer?.renderContents&&data.sections?.['cart-drawer']){drawer.classList.remove('is-empty');drawer.renderContents(data);}else{location.assign(cartPath);}
      }catch(failure){if(added){location.assign(cartPath);return;}error.textContent=failure.message||root.dataset.error;error.hidden=false;}
      finally{busy=false;packs.forEach(x=>x.disabled=false);atc.removeAttribute('aria-busy');update();}
    });
    root.cleanup=()=>{window.removeEventListener('scroll',syncSticky);window.removeEventListener('resize',syncSticky);};update();
  }
  document.querySelectorAll('[data-eyewear]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-eyewear]').forEach(init));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-eyewear]').forEach(x=>x.cleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coreva-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coreva-ugc-video')) {
  customElements.define('coreva-ugc-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const video = this.querySelector('video');
      const button = this.querySelector('.cv-video-start');
      if (!video || !button) return;
      this.initialized = true;
      button.addEventListener('click', () => {
        const playback = video.play();
        if (playback) playback.catch(() => { button.hidden = false; });
      });
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coreva-product"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('coreva-product'))customElements.define('coreva-product',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
  this.form=this.querySelector('form');this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.track=this.querySelector('[data-gallery]');this.slides=[...this.querySelectorAll('[data-media-id]')];this.buttons=[...this.querySelectorAll('[data-main-add],[data-sticky-add]')];this.index=0;
  this.form.addEventListener('submit',e=>this.add(e),{signal});this.form.querySelector('[name=id]').addEventListener('change',()=>this.variant(),{signal});
  this.addEventListener('click',e=>{const thumb=e.target.closest('[data-thumb]');if(thumb)this.go(this.slides.findIndex(s=>s.dataset.mediaId===thumb.dataset.thumb));if(e.target.closest('[data-gallery-prev]'))this.go(this.index-1);if(e.target.closest('[data-gallery-next]'))this.go(this.index+1);},{signal});
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'){e.preventDefault();this.go(this.index+1);}if(e.key==='ArrowLeft'){e.preventDefault();this.go(this.index-1);}},{signal});
  this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{const width=this.track.clientWidth;if(!width)return;this.index=Math.min(this.slides.length-1,Math.max(0,Math.round(this.track.scrollLeft/width)));const count=this.querySelector('[data-gallery-count]');if(count)count.textContent=(this.index+1)+' / '+this.slides.length;this.querySelectorAll('[data-thumb]').forEach((el,i)=>{if(i===this.index)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');});this.slides.forEach((el,i)=>{if(i!==this.index)el.querySelectorAll('video').forEach(v=>v.pause());});});},{signal,passive:true});
  this.observer=new IntersectionObserver(entries=>{const entry=entries[0];this.querySelector('[data-sticky]').hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});this.observer.observe(this.querySelector('[data-main-add]'));this.variant(false);
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.ready=false;}
 go(index){index=Math.max(0,Math.min(this.slides.length-1,index));this.track.scrollTo({left:index*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 variant(updateURL=true){const id=this.form.querySelector('[name=id]').value;const template=this.querySelector('template[data-variant="'+id+'"]');if(!template)return;this.available=template.dataset.available==='true';this.querySelector('[data-main-price]').innerHTML=template.content.querySelector('[data-variant-main]').innerHTML;this.querySelector('[data-sticky-price]').innerHTML=template.content.querySelector('[data-variant-sticky]').innerHTML;this.buttons.forEach(b=>{b.disabled=!this.available||!!this.pending;b.querySelector('[data-add-label]').textContent=this.available?this.labels.add:this.labels.soldOut;});if(template.dataset.media){const index=this.slides.findIndex(s=>s.dataset.mediaId===template.dataset.media);if(index>=0)this.go(index);}if(updateURL){const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState({},'',url);} }
 async add(event){
  event.preventDefault();if(this.pending||!this.available||!this.form.reportValidity())return;
  const drawer=document.querySelector('cart-drawer');const error=this.querySelector('[data-error]');error.hidden=true;this.pending=true;this.buttons.forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true');});this.querySelector('[data-loading]').hidden=false;
  const body=new FormData(this.form);if(drawer&&typeof drawer.getSectionsToRender==='function'){body.set('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));body.set('sections_url',location.pathname+location.search);drawer.setActiveElement(event.submitter||this.querySelector('[data-main-add]'));}
  let added=false;try{
   const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});const data=await response.json();if(!response.ok||data.status)throw new Error(typeof data.description==='string'?data.description:this.labels.error);added=true;
   if(!drawer||!data.sections?.['cart-drawer']||!data.sections?.['cart-icon-bubble']){location.assign(this.dataset.cartUrl);return;}
   drawer.classList.remove('is-empty');drawer.renderContents(data);
   if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'coreva-product',productVariantId:body.get('id'),cartData:data});
  }catch(failure){if(added){location.assign(this.dataset.cartUrl);return;}error.textContent=failure instanceof TypeError?this.labels.error:failure.message;error.hidden=false;}
  finally{this.pending=false;this.buttons.forEach(b=>{b.disabled=!this.available;b.removeAttribute('aria-busy');});this.querySelector('[data-loading]').hidden=true;}
 }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
